(function($) {
  $.fn.extend({
    cwTooltip: function(options){
      var $tt;
      var timer;
      var popover_timer;
      var popover = (options && options['popover']);
      var speed = 250;
      var ttShow = function($el, txt) {
        clearTimeout(timer);
        $el.attr('title', '');
        var inner_class = popover ? 'c-alert' : 'cw-tooltip-inner';
        $tt = $('<div/>').addClass('cw-tooltip').css({
          opacity: 0,
          visibility: 'hidden'
        }).append($('<div/>').addClass(inner_class).text(txt));
        if(popover) {
          $tt.addClass('cw-popover');
        } else if (txt.length > 80) {
          $tt.addClass('cw-tooltip-xl');
        } else if (txt.length > 40) {
          $tt.addClass('cw-tooltip-large');
        }
        $('body > .cw-tooltip').remove();
        $('body').append($tt);
        setTimeout(function(){
          var x = $el.offset().left + ($el.width() / 2);
          var y = $el.offset().top + $el.height();
          if (x > $('body').width() - $tt.width()/2) {
            if(popover){
              $tt.addClass('cw-popover--right-aligned');
            }else{
              x = $('body').width() - $tt.width()/2;
            }
          } else if (x < $tt.width()/2) {
            x = $tt.width()/2;
          }
          $tt.css({
            left: x,
            top: y
          });
          timer = setTimeout(function(){
            $tt.css({
              opacity: 1,
              visibility: 'visible'
            });
          }, speed);
        }, 0);
      };
      var ttHide = function($el, txt) {
        clearTimeout(timer);
        if ($tt) {
          $tt.css({
            opacity: 0
          });
          timer = setTimeout(function(){
            $tt.remove();
            $el.attr('title', txt);
          }, speed);
        }
      };
      var popoverHide = function($el, txt, delay) {
        clearTimeout(popover_timer);
        var timeout = delay || 1000;
        popover_timer = setTimeout(function(){
          ttHide($el, txt);
        }, timeout);
      };
      $(this).each(function(){
        var tag_name = $(this).get(0).tagName;
        var txt = $(this).attr('title');
        if(popover){
          if(txt && $(this).is(':visible')){
            ttShow($(this), txt);
            if($('html').hasClass('mod-touch')){
              $('body').on('touchstart.cwPopover', function(evt){
                popoverHide($(this), txt);
                $('body').off('touchstart.cwPopover');
              });
            }else{
              $(this).on('mouseleave', function(){
                popoverHide($(this), txt);
              });
            }
            popoverHide($(this), txt, 20000);
          }
        } else if (txt && !$('html').hasClass('mod-touch')) {
          var event_in, event_out, $element_in, $element_out;
          if (tag_name == "INPUT") {
            event_in = 'focus';
            event_out = 'blur';
          } else {
            event_in = 'mouseenter';
            event_out = 'mouseleave';
          }
          $(this).on(event_in, function(){
            ttShow($(this), txt);
          });
          $(this).on(event_out, function(){
            ttHide($(this), txt);
          });
        } else if (txt) {
          $(this).on('touchstart.cwTooltip', function(evt){
            evt.stopPropagation();
            var $_this = $(this);
            ttShow($_this, txt);
            $('body').on('touchstart.cwTooltip', function(evt){
              ttHide($_this, txt);
              $('body').off('touchstart.cwTooltip');
            });
          });
        }
      });
    }
  })

  $(document).ready(function(){
    $('.cw-has_tooltip').cwTooltip();
  })
})(jQuery);
